(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("createElementX", [], factory);
	else if(typeof exports === 'object')
		exports["createElementX"] = factory();
	else
		root["createElementX"] = factory();
})(window, function() {
return 